import { render, staticRenderFns } from "./WButton.vue?vue&type=template&id=9a7f122c&scoped=true&"
import script from "./WButton.vue?vue&type=script&lang=js&"
export * from "./WButton.vue?vue&type=script&lang=js&"
import style0 from "./WButton.vue?vue&type=style&index=0&id=9a7f122c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7f122c",
  null
  
)

export default component.exports